import { render, staticRenderFns } from "./safari-blocked.vue?vue&type=template&id=459ef8f1&scoped=true&"
import script from "./safari-blocked.vue?vue&type=script&lang=js&"
export * from "./safari-blocked.vue?vue&type=script&lang=js&"
import style0 from "./safari-blocked.vue?vue&type=style&index=0&id=459ef8f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459ef8f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459ef8f1')) {
      api.createRecord('459ef8f1', component.options)
    } else {
      api.reload('459ef8f1', component.options)
    }
    module.hot.accept("./safari-blocked.vue?vue&type=template&id=459ef8f1&scoped=true&", function () {
      api.rerender('459ef8f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/template/modules/safari-blocked.vue"
export default component.exports